import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation } from '/api/service-hooks';
import { SupportContentType, IBeetleId } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

export const useUpdateNote = (
  type: SupportContentType,
  options?: UseMutationOptions<
    CommonSuccess,
    GenericFailure | Error,
    { id: IBeetleId; noteId: string; env: Environment; note: string }
  >
) => {
  const service = methods(type);
  return useEitherMutation(({ id, noteId, note, env }) => service.updateNote(id, noteId, note, env), {
    ...options,
  });
};
